import { set } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { TYPE_PARITY } from 'frontend-utils/utils/constants/constant-values';
import { APIGATEWAY, MEALTYPES } from 'lumen/utils/constants/general-constants';
import getTodayUtc from 'lumen/utils/dates/get-today-utc';

export default class HotelParityOverviewRoute extends Route {
  queryParams = {
    maxPersons: {
      refreshModel: true,
    },
  };

  @service access;
  @service ajax;
  @service('hotel-and-market') hotelAndMarketService;
  @service liveupdate;
  @service store;
  @service transition;

  activate() {
    super.activate(...arguments);
    set(this, 'liveupdate.parityOverviewTabOpen', true);
  }

  beforeModel(transition) {
    if (!this.access.hasParityOverview) {
      this.transition.redirectToTab(transition, 'hotel.parity.list');
    } else {
      this.transition.validateParityOverviewQueryParams(transition);
    }
  }

  deactivate() {
    set(
      // eslint-disable-next-line ember/no-controller-access-in-routes
      this.controllerFor('hotel.parity.overview'),
      'parityAnalyticsView',
      false,
    );
    set(this, 'liveupdate.parityOverviewTabOpen', false);
  }

  generateURL(extractDate = getTodayUtc()) {
    let url = `${this.ajax?.host}/apigateway/v1/app/parityanalytics/api?`;

    // Static market id Pestana PA for the time being
    url += `subscription_id=${this.hotelAndMarketService.hotel?.id}&`;

    // Always suffix with the date
    url += `extract_date=${extractDate}`;

    return url;
  }

  model(params) {
    const model = {
      parities: [],
      isLoadingParityData: true,
    };

    const today = this.hotelAndMarketService.getLocalTime();
    const dateRangeStart = today.format('YYYY-MM-DD');
    const dateRangeEnd = today

      .add(
        this.hotelAndMarketService.hotel?.getParityExportShopDays(TYPE_PARITY),
        'day',
      )
      .format('YYYY-MM-DD');

    const requestPeriods = {
      namespace: APIGATEWAY,
      typeKey: 'parity',
      los: this.hotelAndMarketService.hotel?.defaultLosParity[0],
      persons: params.maxPersons,
      membershiptype: 0,
      from_date_range_start: dateRangeStart,
      from_date_range_end: dateRangeEnd,
      hotel_id: this.hotelAndMarketService.hotel?.id,
    };

    const paritiesInStore = this.store
      .peekAll('parity', requestPeriods)
      .filter(
        (parity) =>
          parity.period?.day?.date &&
          parity.period.day.date.isSameOrBefore(dateRangeEnd, 'day') &&
          parity.period.day.date.isSameOrAfter(dateRangeStart, 'day') &&
          !parity.isOutOfSync,
      );
    if (!paritiesInStore.length) {
      this.store.query('parity', requestPeriods).then((parities) => {
        set(model, 'isLoadingParityData', false);
        set(
          model,
          'parities',
          parities.filter((parity) => !parity.isOutOfSync),
        );
      });
    } else {
      set(model, 'isLoadingParityData', false);
      set(model, 'parities', paritiesInStore);
    }

    this.liveupdate.updateSelection({
      currentHotelId: this.hotelAndMarketService.hotel?.id,
      month: today.format('YYYY-MM'),
      los: requestPeriods.los,
      maxPersons: requestPeriods.persons,
      mealtype: MEALTYPES.ANY,
    });

    return model;
  }
}
